<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">Login</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">Login</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <section class="contact-touch-area pt-85 pb-90">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-9">
                        <div class="contact-touch-part">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="secton-title text-center">
                                        <h5 class="title">Login to your account</h5>
                                        <p>Join other 2000+ users!</p>
                                    </div>
                                </div>
                            </div>
                            <form id="contact-form" @submit.prevent="login" autocomplete="off">
                                <small v-if="invalid" style="color: red">Wrong email or password. Please try again</small>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="input-box mt-35">
                                            <input v-model="form.email" name="email" type="email" placeholder="Your Email">
                                            <small style="color: red" v-if="error && errors.email">{{ errors.email[0] }}</small>
                                        </div>
                                    </div>
                                   
                                    <div class="col-lg-6">
                                        <div class="input-box mt-35">
                                            <input v-model="form.password" name="password" type="password" placeholder="Password">
                                            <small style="color: red" v-if="error && errors.password">{{ errors.password[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="forgot">
                                        <span @click="forgotdirect()" class="forgotH">Forgot password</span> | <span @click="registerdirect()" class="forgotH"> Register</span>
                                    </div>

                                    <div class="col-lg-12">
                                        <div class="input-box mt-35 text-center">
                                            <button type="submit">Login</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="vld-parent">
            <loading :active.sync="isLoading"
                     :can-cancel="true"
                     :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>

<script>
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
    export default {
        name: "Login",
        components: {
            Loading
        },
        data() {
            return {
                invalid: false,
                isLoading: false,
                fullPage: true,
                error: false,
                errors: {},
                form: {
                    name: '',
                    email: '',
                }
            }
        },
        methods:{
            forgotdirect(){
                this.$router.push('/reset-password')
            },
            registerdirect(){
                this.$router.push('/register')
            },

            login() {
                this.isLoading = true;
                this.$auth.login({
                    params: {
                        email: this.form.email,
                        password: this.form.password,
                    },
                    success: function () {
                        this.isLoading = false;
                    },
                    error: function (resp) {
                        this.isLoading = false;
                        if (resp.response.data.errors) {
                            this.error = true;
                            this.errors = resp.response.data.errors;
                        }

                        if (resp.response.data.error) {
                            if(resp.response.data.error == "Account has not been verified"){
                                this.$router.push('/notVerified/' + this.form.email)
                            }else{
                                this.invalid = true;
                                this.errors = resp.response.data.error;
                            }
                            
                        }

                    },
                    rememberMe: true,
                    redirect: '/',
                    fetchUser: true,
                });
            }
        }
    }
</script>

<style scoped>
    .forgot {
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px ;
    }
    .forgotH:hover {
        text-decoration: underline;
        color: blue;
        cursor: pointer;
    }

</style>